import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from '@/lib/cn';

/** Ported from PulseOS (see HMS_UI_REDESIGN_ANALYSIS.md). */
const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // Fixed small radius, deliberately not the brand rounded-sm scale — at
      // 16px box size, a radius derived from a hospital's (often ~10px) card
      // radius reads as a circle, not a checkbox. Checkboxes conventionally
      // stay near-square regardless of how round that hospital likes its
      // cards and buttons.
      'peer grid h-4 w-4 shrink-0 place-content-center rounded-[3px] border border-teal shadow-sm ' +
        'focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-teal/25 ' +
        'disabled:cursor-not-allowed disabled:opacity-50 ' +
        'data-[state=checked]:bg-teal data-[state=checked]:text-white',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="grid place-content-center text-current">
      <Check className="h-3.5 w-3.5" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
